import { useTranslation } from 'react-i18next';
import { QSpinner, QText } from '@qualio/ui-components';
import { Product } from '../../../types';
import ItemWithIdAndNameLabel from './ItemWithIdAndNameLabel';
import { CodeWithNameTooltip } from './ItemWithCodeAndNameLabel';
import { EMPTY_FILTER_VALUE } from '../../../types/qualityEvent';

const ActiveProductFilter = ({
  value,
  productsMap,
  isMultiSelect = false,
  isMultiSelectEventsListEnabled = false,
}: {
  value: unknown;
  productsMap: Record<string, Product>;
  isMultiSelect?: boolean;
  isMultiSelectEventsListEnabled?: boolean;
}) => {
  const { t } = useTranslation();
  if (value === EMPTY_FILTER_VALUE) {
    return <QText as="span">{t('common.labels.emptyProducts')}</QText>;
  }
  const id = value as string;
  const product = productsMap[id];
  if (product) {
    if (isMultiSelectEventsListEnabled) {
      return <CodeWithNameTooltip code={product.displayId} name={product.name} />;
    }
    if (isMultiSelect) {
      return (
        <QText as="span">
          {product.displayId} - {product.name}
        </QText>
      );
    }
    return <ItemWithIdAndNameLabel itemName={product.name} itemId={product.displayId} setMinWidth={false} />;
  }
  return <QSpinner size="sm" />;
};

export default ActiveProductFilter;
